module.exports = __webpack_public_path__ + "static/media/report_icon.365dbd92.png";